export const AGE_RANGES = ["Under 18", "18–24", "25–34", "35–44", "45–54", "55+"];
export const LANGUAGES = ["English", "Hindi", "Hinglish", "Spanish", "Portuguese", "French", "German", "Arabic", "Other"];
export const EXPERIENCE_LEVELS = ["Just starting", "Beginner", "Intermediate", "Advanced", "Professional"];


export const INTERESTS = [
  "Technology", "AI", "Business", "Finance", "Marketing", "Health & Fitness",
  "Food", "Travel", "Gaming", "Education", "Science", "Design", "Productivity",
  "Music", "Fashion", "Sports", "Personal Development", "Parenting",
];

export const CONTENT_STYLES = [
  "Educational", "Entertaining", "Analytical", "Storytelling", "Opinionated",
  "Experimental", "Inspirational", "Documentary", "Humorous",
];

export const CONTENT_FORMATS = [
  "Short-form", "Long-form", "Talking head", "Screen recording",
  "Voiceover", "Tutorial", "Interview", "Commentary",
];

export const GOALS = [
  "Audience growth", "Authority", "Monetization", "Leads", "Community", "Personal brand",
];

export const CREATION_TIME = ["< 2 hrs/week", "2–5 hrs/week", "5–10 hrs/week", "10+ hrs/week"];
export const EDITING_SKILL = ["None", "Basic", "Intermediate", "Advanced"];
export const EQUIPMENT_LEVEL = ["Phone only", "Entry gear", "Prosumer", "Professional studio"];
export const BUDGET = ["No budget", "< $100/mo", "$100–$500/mo", "$500+/mo"];
export const PLATFORMS = ["YouTube", "Instagram"];

export const NICHE_CATEGORIES = [
  "AI & Automation", "Personal Finance", "Software Engineering", "Health & Wellness",
  "Digital Marketing", "Productivity Systems", "Startups", "Design & Creativity",
  "Gaming", "Education", "Career Growth", "Content Creation",
];
